import http from './config'

// post 请求
export const POST = (url, data = {}) => {
  return http.post(url, data)
}

// get 请求
export const GET = (url, data = {}) => {
  return http.get(url, {
    params: data
  })
}

// 上传游戏图片
export const uploadImg = (data) => {
  return POST('/upload/img', data)
}

// 获取游戏图片
export const fileInfo = (data) => {
  return GET('/file/info', data)
}



// WEBPACK FOOTER //
// ./src/api/index.js